import { newrelic } from "@jti/fe-clients";
import type { PgsApiContract } from "@jti/fe-common";
import { getConfig } from "@jti/fe-common";

import { createLegacyApiWarningAttributes, getIsEvo } from "../../utils";

import { PgsApiEvo } from "./PgsApiEvo";
import { PgsApiLegacy } from "./PgsApiLegacy";

/***
  PgsApi - Payment Gateway Service API
 */
export class PgsApi {
  static init(): PgsApiContract {
    const config = getConfig();

    if (config.USE_EVO_ONLY) {
      return new PgsApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.PGS_URL)) {
      return new PgsApiEvo(config.PGS_URL, config.PGS_X_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"]);
    }
    newrelic.sendWarning(
      "PgsApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.PGS_URL)
    );

    return new PgsApiLegacy(config.PGS_URL, config.PGS_X_DES_AK_TENANT_TOKEN);
  }
}
